import { UserCircle } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerPeopleSpec: ModuleSpec = {
  id: "customer-people",
  icon: UserCircle,
  i18n: {
    namespace: "modules",
    titleKey: "customer-people.title",
    descriptionKey: "customer-people.description",
  },
  nav: {
    path: "/customers/people",
    group: "observe",
    order: 10,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Manage customer profiles and attributes",
  },
};
